import { KYMW5500Component } from './kymw5500.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { UpdateImageFileListModel } from './vo/update-Image-file-list.model';

/**
 * EC画像メンテ画面の値を管理するクラス
 *
 * @export KYMW5500Model
 * @class KYMW5500Model
 */
export class KYMW5500Model {

  kymw5500Component: KYMW5500Component;

  // 画像ファイルリスト
  public imageFileList: Array<any> = [];

  /**
   * サーバより取得した画像ファイルリストを反映する
   */
  public updateImageFileList(serverData: any): void {
    if (serverData == null) {
      this.imageFileList = [];
    } else {
      this.imageFileList = this.convObjectToArrayCollection(serverData);
    }

  }

  /**
   * 画像ファイル更新用VO取得
   */
  public getUpdateImageFileListVo(): any {
    const vo: UpdateImageFileListModel = new UpdateImageFileListModel();
    const list: Array<any> = new Array<any>();
    let obj: any;
    for (let i = Number(0); i < this.imageFileList.length; i++) {
      if (PlessViewUtilsSub.isEmpty(this.imageFileList[i].ErrorMessage)) {
        obj = new Object();
        obj.ImageId = this.imageFileList[i].ImageId;
        obj.ImageFileName = this.imageFileList[i].ImageFileName;
        obj.ImagePathId = this.imageFileList[i].ImagePathId;
        list.push(obj);
      }
    }
    vo.imageFileList = list;

    return vo;
  }

  /**
   * 引数のオブジェクトをArrayCollectionに変換して返却する。
   *  （nullオブジェクト対応版：nullの場合、空のArreyCollectionを返却する）
   */
  public convObjectToArrayCollection(obj: any): Array<any> {
    let retList: Array<any> = [];
    if (obj != null) {
      if (obj.constructor === Array) {
        retList = obj;
      } else {
        retList = [obj];
      }
    }
    return retList;
  }

}
